const styles = theme => ({
  root: {
    height: 40,

    [theme.breakpoints.down("sm")]: {
      height: 32,
    }
  }
});

export default styles;